import { useMutation } from "react-query";
import InternalStudyListService from "@services/internal-study-list-service";

export const useAddTrainessToProcessGroupMutation = () => {
  return useMutation(InternalStudyListService.addTrainessToGroup);
};
